import { Button } from '@heroui/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import authBg from '@/assets/auth-bg.png'

export default function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center p-5 relative"
      style={{ backgroundImage: `url(${authBg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-md z-0 transition" />

      <div className="w-full max-w-md relative z-10 text-center animate-in fade-in slide-in-from-bottom-4 duration-700">
        <div className="mb-6">
          <h1 className="text-9xl font-black tracking-widest text-transparent bg-clip-text bg-gradient-to-br from-blue-400 via-indigo-500 to-purple-600 drop-shadow-lg select-none">
            404
          </h1>
        </div>

        <div className="space-y-3 mb-8">
          <h2 className="text-2xl font-bold text-white tracking-tight">
            {t('common.not_found_title')}
          </h2>
          <p className="text-white/60 text-sm max-w-sm mx-auto leading-relaxed">
            {t('common.not_found_desc')}
          </p>
        </div>

        <div className="max-w-xs mx-auto">
          <Button
            fullWidth
            size="lg"
            onClick={() => navigate('/')}
            className="font-semibold shadow-xl shadow-blue-500/20"
          >
            {t('common.back_to_home')}
          </Button>
        </div>
      </div>
    </div>
  )
}
